import { ProjectNavigationType } from "./types";

export const useProjectNavigation = (): ProjectNavigationType => {
  const openToCreateANewProject = () => {
    window.open(
      "/dashboard/projects?_action=create&title=New+project&description=Add+description",
      "_blank",
    );
  };

  return {
    openToCreateANewProject,
  };
};
